<template>
  <b-container fluid>
    <b-row>
      <b-tabs
        class="w-100"
      >
        <b-tab
          v-for="(tab, index) in diagnostics"
          :active="tab.active"
          :key="index"
          :title="tab.name"
        >
          <component
            :is="tab.component"
            :items="tab.items"
            :selected-diagnostics="tab.selected"
            :loading="loading"
            @update:selected-diagnostics="setSelectedDiagnostics($event, tab.module)"
          />
        </b-tab>
      </b-tabs>
    </b-row>
  </b-container>
</template>

<script>
import { Modules } from 'sigma-mappings';
import AccordionPanel from '@/components/AccordionPanel';
import ChromatographyTab from './ChromatographyTab';
import PhysicalChemicalTab from './PhysicalChemicalTab';

export default {
  name: 'DiagnosticList',
  components: {
    AccordionPanel,
    ChromatographyTab,
    PhysicalChemicalTab,
  },
  props: {
    chromatography: Object,
    physicalChemical: Object,
    loading: Boolean,
    selectedChromatographyDiagnostics: Array,
    selectedPhysicalChemicalDiagnostics: Array,
  },
  computed: {
    diagnostics() {
      return [
        {
          module: Modules.CHROMATOGRAPHY,
          name: this.$t('enums.engineering.chromatography.name'),
          items: this.chromatography,
          component: ChromatographyTab,
          selected: this.selectedChromatographyDiagnostics,
        },
        {
          module: Modules.PHYSICAL_CHEMICAL,
          name: this.$t('enums.engineering.physical-chemical.name'),
          items: this.physicalChemical,
          component: PhysicalChemicalTab,
          selected: this.selectedPhysicalChemicalDiagnostics,
        },
      ];
    },
  },
  methods: {
    setSelectedDiagnostics(values, module) {
      if (module === Modules.CHROMATOGRAPHY) {
        this.chromatographyDiagnosticsHandler(values);
        return;
      }
      this.physicalChemicalDiagnosticsHandler(values);
    },
    chromatographyDiagnosticsHandler(value) {
      this.$emit('update:selected-chromatography-diagnostics', value);
    },
    physicalChemicalDiagnosticsHandler(value) {
      this.$emit('update:selected-physical-chemical-diagnostics', value);
    },
  },
};
</script>

<style lang="sass" scoped>
  .diagnostic-list
    &__tab
      min-width: calc(100vw - 150px)
</style>
